import React from 'react';
import { EmailBlock, HeaderBlockContent } from '../types';

interface HeaderBlockProps {
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  isDarkMode: boolean;
}

export const HeaderBlock: React.FC<HeaderBlockProps> = ({
  block,
  isSelected,
  onSelect,
  isDarkMode
}) => {
  const content = block.content as HeaderBlockContent;

  const style: React.CSSProperties = {
    backgroundColor: content.backgroundColor || '#ffffff',
    padding: content.padding || '20px',
    ...block.styles
  };

  return (
    <div style={style} className="border-b border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between">
        {/* Logo */}
        {content.logo?.src ? (
          <div>
            {content.logo.link ? (
              <a href={content.logo.link}>
                <img
                  src={content.logo.src}
                  alt={content.logo.alt || 'Logo'}
                  style={{ width: content.logo.width || '150px' }}
                />
              </a>
            ) : (
              <img
                src={content.logo.src}
                alt={content.logo.alt || 'Logo'}
                style={{ width: content.logo.width || '150px' }}
              />
            )}
          </div>
        ) : (
          <div className={`
            px-4 py-2 border-2 border-dashed rounded
            ${isDarkMode ? 'border-gray-600 text-gray-400' : 'border-gray-300 text-gray-500'}
          `}>
            Logo
          </div>
        )}

        {/* Navigation */}
        {content.navigation && content.navigation.length > 0 && (
          <nav className="flex gap-4">
            {content.navigation.map((item, index) => (
              <a
                key={index}
                href={item.link}
                className={`
                  text-sm
                  ${isDarkMode ? 'text-gray-300 hover:text-white' : 'text-gray-700 hover:text-gray-900'}
                `}
              >
                {item.text}
              </a>
            ))}
          </nav>
        )}
      </div>
    </div>
  );
};
